import { Writable } from "stream";
import { getLogLevel } from "./helpers";
export class LogtailStream extends Writable {
    constructor(_logtail) {
        super();
        this._logtail = _logtail;
    }
    _write(chunk, encoding, next) {
        // Sanity check for the format of the log
        const jsonString = chunk.toString();
        let log;
        // Should be JSON parsable
        try {
            log = JSON.parse(jsonString);
        }
        catch (e) {
            return next(e);
        }
        // Log should have string `msg` key, > 0 length
        if (typeof log.msg !== "string" || !log.msg.length) {
            return next();
        }
        // Logging meta data
        const meta = {};
        // Copy `time` if set
        if (typeof log.time === "string" || log.time.length) {
            const time = new Date(log.time);
            if (!isNaN(time.valueOf())) {
                meta.dt = time;
            }
        }
        // Carry over any additional data fields
        Object.keys(log)
            .filter(key => ["time", "msg", "level", "v"].indexOf(key) < 0)
            .forEach(key => (meta[key] = log[key]));
        // Determine the log level
        let level;
        try {
            level = getLogLevel(log.level);
        }
        catch (_) {
            return next();
        }
        // Log to Logtail
        void this._logtail.log(log.msg, level, meta);
        next();
    }
}
//# sourceMappingURL=bunyan.js.map